import graphql__e252c96d144159eec3d1 from "./__generated__/PageSectionParticipativeModuleResults_pageSection.graphql.js";import { Suspense } from "react";
import { graphql, useFragment } from "react-relay";

import PageSectionBlockWithTitleAndDescription from "./PageSectionBlockWithTitleAndDescription";
import ContainerWithSidebar from "../Sidebar/ContainerWithSidebar";
import ParticipativeModuleResultsFormFields from "../ParticipativeModuleResultsFormField/ParticipativeModuleResultsFormFields";
import Spinner from "../Utils/Spinner";

const PageSectionParticipativeModuleResults = props => {
  const pageSection = useFragment(
    PageSectionParticipativeModuleResults_pageSection,
    props.pageSection
  );

  const {
    title,
    description,
    iconClass,
    displayQuestionsLabel,
    displayParticipationData,
    results,
    columnsRatio,
    columnsOrder,
    sidebar
  } = pageSection;

  if (!results || results.length === 0) return null;

  // Determine the title level based on whether a title is displayed or not on the page
  // section.
  const formFieldsTitleLevel = title && title !== "" ? "h3" : "h2";

  return (
    <div className="container page-section page-section-participative-module-results">
      <ContainerWithSidebar
        sidebar={sidebar}
        columnsRatio={columnsRatio}
        columnsOrder={columnsOrder}
      >
        <PageSectionBlockWithTitleAndDescription
          title={title}
          description={description}
          iconClassName={iconClass}
        >
          <Suspense fallback={<Spinner className="padding-md" />}>
            <ParticipativeModuleResultsFormFields
              pageSection={pageSection}
              displayQuestionsLabel={displayQuestionsLabel}
              displayParticipationData={displayParticipationData}
              TitleLevel={formFieldsTitleLevel}
            />
          </Suspense>
        </PageSectionBlockWithTitleAndDescription>
      </ContainerWithSidebar>
    </div>
  );
};

const PageSectionParticipativeModuleResults_pageSection = graphql__e252c96d144159eec3d1;

export default PageSectionParticipativeModuleResults;
